import { render, staticRenderFns } from "./MessageField.vue?vue&type=template&id=fb80165e&"
import script from "./MessageField.vue?vue&type=script&lang=ts&"
export * from "./MessageField.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports